import React from 'react';
import InnerBanner from '../components/InnerBanner';

const RefundDisputePolicy = () => {
    return (
        <>
            <InnerBanner title="Refund and Dispute Policy" />
            <div className="condition">
                <div className="container">
                    <div className="inner-head">
                        <h2>Refund and Dispute Policy</h2>
                    </div>

                    {/* Refund Policy Section */}
                    <section className="cards">
                        <h3>Refund Policy</h3>
                        <p>
                            CloudifyDocs offers a <strong>14-day free trial</strong> for all new customers to evaluate our services before making a purchase. By subscribing to CloudifyDocs, you acknowledge and agree to the following terms:
                        </p>

                        <h4>No Refunds</h4>
                        <p>
                            All payments made to CloudifyDocs are <strong>final and non-refundable</strong>, except for annual subscriptions, where a pro-rata refund may be issued for unused periods (excluding applicable government taxes and a CAD $10 service fee).
                        </p>
                        <p>We do not offer refunds, charge reversals, or credits under any circumstances, including but not limited to:</p>
                        <ul>
                            <li>Non-use of the service after purchase or subscription renewal.</li>
                            <li>Accidental purchases, duplicate accounts, or mistaken payments.</li>
                            <li>Changes in business needs, customer dissatisfaction, or failure to cancel before a renewal date.</li>
                            <li>Account termination due to violation of our Terms of Service or any other policy.</li>
                        </ul>
                    </section>

                    {/* Security and Data Protection Section */}
                    <section className="cards">
                        <h3>Security and Data Protection</h3>
                        <p>CloudifyDocs follows industry-standard security measures to protect user data. However, we are not liable for:</p>
                        <ul>
                            <li>Loss, corruption, or deletion of any documents due to user action, third-party interference, or unforeseen circumstances such as cyberattacks.</li>
                            <li>Unauthorized access to an account resulting from user negligence, weak passwords, or phishing attacks.</li>
                            <li>Service disruptions due to maintenance, force majeure events, or external factors beyond our control.</li>
                        </ul>
                        <p>
                            Users are responsible for maintaining strong passwords and enabling multi-factor authentication to safeguard their accounts. Refunds will not be issued for any losses caused by compromised accounts or third-party actions.
                        </p>
                    </section>

                    {/* Subscription and Cancellations Section */}
                    <section className="cards">
                        <h3>Subscription and Cancellations</h3>
                        <p>Customers can cancel their subscriptions at any time through their CloudifyDocs account settings. Cancellations will take effect at the end of the billing cycle.</p>
                        <p>Pro-rata refunds on annual subscriptions will be provided for unused service periods (excluding government taxes and a CAD $10 service fee).</p>
                    </section>

                    {/* Dispute Resolution Section */}
                    <section className="cards">
                        <h3>Dispute Resolution</h3>
                        <p>We strive to resolve all billing or service-related disputes in a fair and transparent manner. If you encounter any issues, please contact us before initiating a chargeback or external dispute.</p>

                        <h4>Dispute Submission Process</h4>
                        <p>To file a dispute, email <a href="mailto:support.cloudifydocs@caditsolutions.com">support.cloudifydocs@caditsolutions.com</a> with the subject line <strong>"Dispute – [Your Account Name]"</strong> and include:</p>
                        <ul>
                            <li>Full Name and Account Email</li>
                            <li>Transaction Details (Date, Amount, and Payment Method)</li>
                            <li>Nature of the Dispute (Billing issue, unauthorized charge, service access, etc.)</li>
                            <li>Supporting Documentation (Screenshots, transaction records, or error messages)</li>
                        </ul>
                        <p>We will acknowledge receipt of the dispute within <strong>3 business days</strong> and respond within <strong>7 business days</strong>.</p>
                    </section>

                    {/* Chargebacks and Unauthorized Disputes Section */}
                    <section className="cards">
                        <h3>Chargebacks and Unauthorized Disputes</h3>
                        <p>Filing a chargeback without first contacting our support team may result in:</p>
                        <ul>
                            <li>Immediate suspension or termination of your CloudifyDocs account.</li>
                            <li>Legal action to recover unpaid amounts, including dispute fees charged by our payment processor.</li>
                            <li>The inability to use CloudifyDocs services in the future.</li>
                        </ul>
                        <p>CloudifyDocs reserves the right to make final decisions on dispute resolutions, account reinstatements, and service terminations.</p>
                    </section>

                    {/* Policy Changes Section */}
                    <section className="cards">
                        <h3>Changes to this Policy</h3>
                        <p>
                            We reserve the right to modify or update this policy at any time without prior notice. Continued use of CloudifyDocs after any changes constitutes acceptance of the revised policy.
                        </p>
                    </section>
                </div>
            </div>
        </>


        
    );
};

export default RefundDisputePolicy;
